export const formatPrice = (price) => {
  if (!price && price !== 0) return 'PKR 0';
  return 'PKR ' + Number(price).toLocaleString('en-PK');
};

export const formatDate = (timestamp) => {
  if (!timestamp) return '—';
  const date = typeof timestamp === 'number' ? new Date(timestamp) : timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
  return new Intl.DateTimeFormat('en-PK', { year:'numeric', month:'short', day:'numeric' }).format(date);
};

export const slugify = (text) => text.toLowerCase().replace(/\s+/g,'-').replace(/[^\w-]+/g,'');

export const generateOrderId = () => 'SS-' + Date.now().toString(36).toUpperCase() + Math.random().toString(36).substr(2,4).toUpperCase();

export const truncate = (text, len=100) => text?.length > len ? text.substring(0,len)+'...' : text;

export const getDiscountPercent = (original, sale) => Math.round(((original-sale)/original)*100);

export const ORDER_STATUSES = ['pending','confirmed','processing','shipped','delivered','cancelled'];

export const STATUS_COLORS = {
  pending: 'bg-yellow-100 text-yellow-800',
  confirmed: 'bg-blue-100 text-blue-800',
  processing: 'bg-purple-100 text-purple-800',
  shipped: 'bg-indigo-100 text-indigo-800',
  delivered: 'bg-green-100 text-green-800',
  cancelled: 'bg-red-100 text-red-800',
};

export const PAKISTAN_CITIES = [
  'Karachi','Lahore','Islamabad','Rawalpindi','Faisalabad',
  'Multan','Peshawar','Quetta','Sialkot','Hyderabad',
  'Gujranwala','Bahawalpur','Sargodha','Sukkur','Larkana',
  'Mardan','Kasur','Rahim Yar Khan','Sahiwal','Okara',
  'Wah Cantonment','Dera Ghazi Khan','Mirpur Khas','Nawabshah',
  'Mingora','Abbottabad','Muzaffarabad','Gilgit','Skardu'
];
